import { flushSync } from 'react-dom';

export const useTransitionApi = (props?: {
  skipTransition?: boolean;
  flushSync?: boolean;
}) => {
  const { skipTransition, flushSync: flushSyncOpt = true } = props || {};
  const updateDOM = (callback: () => void, types?: string[]) => {
    if (skipTransition || !(document as any).startViewTransition) {
      const updateCallbackDone = Promise.resolve(callback()).then(() => {});
      const ready = Promise.reject(Error('View transitions unsupported'));
      // Avoid spamming the console with this error unless the promise is used.
      ready.catch(() => {});
      return {
        ready,
        updateCallbackDone,
        finished: updateCallbackDone,
        skipTransition: () => {},
      };
    }

    const fn = () => (flushSyncOpt ? flushSync(callback) : callback());

    const startViewTransition = (document as any).startViewTransition.bind(
      document
    );

    const startWithTypes = () => {
      // The `{ update, types }` object overload (View Transition Types) is
      // newer than the plain callback form. Browsers that only ship the
      // callback form (e.g. Safari 17) throw "Overload resolution failed" on
      // the object, so we drop the type hints rather than the transition.
      try {
        return startViewTransition({ update: fn, types });
      } catch {
        return startViewTransition(fn);
      }
    };

    const transition = types?.length
      ? startWithTypes()
      : startViewTransition(fn);

    return transition as ViewTransition;
  };
  return { updateDOM };
};
